import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=d2031002&scoped=true&"
import script from "./LazyImage.vue?vue&type=script&lang=ts&"
export * from "./LazyImage.vue?vue&type=script&lang=ts&"
import style0 from "./LazyImage.vue?vue&type=style&index=0&id=d2031002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2031002",
  null
  
)

export default component.exports